// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"071eed33","453":"82d13d77","667":"6221dd4b"}[chunkId] + ".chunk.js";
};